import {Component} from 'react';

class CheckboxCard extends Component {
       
    constructor(props) {
        super(props);
        this.state = {
           
        }; 
        this.onChangeValue = this.onChangeValue.bind(this);
    }
     
    onChangeValue(event) {
        this.checked = event.target.checked;
        let slctChange = {value: event.target.value, checked: this.checked,
            buttonText: this.props.itemList.buttonText
        };
        this.props.onSelect(slctChange);
    }

    render() 
    {   
        this.textClass = "checkbox-text shared-text-size";
        
        if (this.props.displayClass){
            this.textClass += this.props.displayClass;
    }
       
    return <>
        <div className="ml-4 text-left">
            <input
                type="checkbox"
                checked={this.props.itemList.checked}
                onChange={this.onChangeValue}
            />
            <span className={this.textClass} 
                style={{ marginLeft: '5px' }}>{this.props.itemList.selectValue}</span>
            {this.props.itemList.desc ?
                <div className="text-left mx-3"><b>Description: </b>{this.props.itemList.desc}</div>
            :
                null
            }
            
        </div>
   
    </>
    }
}

export default CheckboxCard;